import gql from 'graphql-tag';
export const SURVEY_BY_ID = gql`
query ScapeReportSurveyById($id: ID!) {
  SurveyById(id: $id) {
    id
    name
    groupSet {
      edges {
        node {
          id
          questionSet {
            edges {
              node {
                id
                choiceSet {
                  edges {
                    node {
                      id
                      value
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
`